import React from "react";
import { useSelector } from "react-redux";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import PlayBtn from "../../../../assets/images/icons/play-icon.png";

import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/images/back-icon.png";
import { VimplayData } from "../../../../lib/data/vimplay.data";
import { Container } from "react-bootstrap";

const Vimplay = () => {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main">
        <Container>
          <div className=" spribe-page">
            <div className="games-section">
              <div className="headTitle mt-4">
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={() => navigate(-1)}>
                    <img src={BackIcon} alt="back" width={28} />
                  </a>
                </div>

                <div className="title">
                  <h3>Vimplay Games</h3>
                </div>
              </div>
              <ul className="mt-4">
                {Object.values(VimplayData).map((item) => {
                  return (
                    <li className="game-section">
                      <a href={isAuth ? item.redirectUrl : "/login"}>
                        <img src={item.imgUrl} />
                        <div className="casino_overlay">
                          <img src={PlayBtn} />
                        </div>
                        <p>{item.name}</p>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Container>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Vimplay;
